import { render, staticRenderFns } from "./post.vue?vue&type=template&id=5ef47612&"
import script from "./post.vue?vue&type=script&lang=ts&"
export * from "./post.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports